import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface I_IndicatorsFormMeta {
    mediaEntry: FormInputMeta;
    tiBins: FormInputMeta;
    cdmTamper: FormInputMeta;
    dpmTamper: FormInputMeta;
    digitalAudio: FormInputMeta;

}

const indicatorsFormMeta = {} as I_IndicatorsFormMeta;

indicatorsFormMeta.mediaEntry = {
    name: "mediaEntry",
    type: "select",
    label: "Media Entry",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

indicatorsFormMeta.tiBins = {
    name: "tiBins",
    type: "select",
    label: "T I Bins",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

indicatorsFormMeta.cdmTamper = {
    name: "cdmTamper",
    type: "select",
    label: "C D M Tamper",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

indicatorsFormMeta.dpmTamper = {
    name: "dpmTamper",
    type: "select",
    label: "D P M Tamper",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

indicatorsFormMeta.digitalAudio = {
    name: "digitalAudio",
    type: "select",
    label: "Digital Audio",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};


export default indicatorsFormMeta;